module.exports = __webpack_public_path__ + "img/4.d16f3ec3.svg";